/*
 * @Author: zhangsheng
 * @Date: 2025-12-19 14:36:58
 * @LastEditors: zhangsheng
 * @LastEditTime: 2025-12-23 15:21:20
 * @FilePath: \panda-index-sicermem-frontend - 副本\src\App.tsx
 * @Description:
 *
 * Copyright (c) 2025 by zhangsheng , All Rights Reserved.
 */
import './App.less';
import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'mobx-react';
import { EventEmitter } from 'events';
import PCAPP from './pc/index';
import stores from './pc/store';

const Children = PCAPP;
// import "./i18n";

function App() {
  window.share = {
    event: new EventEmitter(),
  };
  window.share.event.setMaxListeners(50);

  return (
    <Provider {...stores}>
      <Children />
    </Provider>
  );
}

export default App;
